var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 10.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM6 8.25a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 8.25ZM6.75 10.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 2.25A5.25 5.25 0 0 0 1.5 7.5v7.125a2.625 2.625 0 0 0 2.625 2.625c.621 0 1.125.504 1.125 1.125v.843c0 1.88 2.272 2.82 3.6 1.492l2.362-2.362a3.75 3.75 0 0 1 2.652-1.098h3.386c2.9 0 5.25-2.35 5.25-5.25V7.5c0-2.9-2.35-5.25-5.25-5.25H6.75ZM3 7.5a3.75 3.75 0 0 1 3.75-3.75h10.5A3.75 3.75 0 0 1 21 7.5V12a3.75 3.75 0 0 1-3.75 3.75h-3.386a5.25 5.25 0 0 0-3.712 1.538L7.79 19.649a.61.61 0 0 1-1.04-.43v-.844a2.625 2.625 0 0 0-2.625-2.625A1.125 1.125 0 0 1 3 14.625V7.5Z"
  })));
};

export default SvgMessage;